export default "__VITE_ASSET__Dc2m8fZy__"